/**
 * Returns true if the JWT's `exp` claim is in the past, or if the token is
 * unparseable. Uses only the payload — no signature verification needed for
 * client-side expiry checks.
 */
export const isJwtExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return typeof payload.exp === "number" && payload.exp * 1000 < Date.now();
  } catch {
    return true; // unparseable → treat as expired
  }
};
